import { Box, BoxProps, Icon, chakra, useSlotRecipe } from '@chakra-ui/react'
import { convertIconSetToChakraSVG } from '../Icon/Icon.utils'
import { IconSizes } from '../../theme/iconSize'

type SnackbarVariant = 'info' | 'success' | 'error' | 'warning' | 'promo'

export type SnackbarProps = BoxProps & {
  variant?: SnackbarVariant
  onClose?: () => void
}

export const Snackbar = (props: SnackbarProps) => {
  const { children, variant = 'info', onClose } = props
  const recipe = useSlotRecipe({ key: 'snackbar' })
  const styles = recipe({ variant })
  return (
    <Box css={styles.container} {...props}>
      {children}
      <chakra.button css={styles.closeButton} onClick={onClose}>
        <Icon as={convertIconSetToChakraSVG('cross')} boxSize={IconSizes.xxs} />
      </chakra.button>
    </Box>
  )
}
